import React from 'react';
import { ModalFooter } from 'reactstrap';
import GetButtons from './getButtons';

const GetModalFooter = (props) => {
  const { handleSubmit, isSubmitting, toggle, mode } = props;

  return (
    <ModalFooter>
      
      <GetButtons
        type="submit"
        onClick={handleSubmit}
        isSubmitting={isSubmitting}
        name={mode === 'add' ? 'Submit' : 'Save'}
      />
      <GetButtons onClick={toggle} type="cancel" />
    </ModalFooter>
  );
};

export default GetModalFooter;
